import freeEmailDomains from '../data/free-email-domains';

/**
 * Validate whether value is an empty value.
 * @param {string} value
 * @returns {boolean} true if value is not empty, else false.
 */
export const isValueNotEmpty = (value: string = '') => {
    value = value.trim();
    if (value && value.length && value.length > 0) {
        return true;
    } else {
        return false;
    }
};

export const restrictedCharacters = ['<', '>'];
/**
 * Validate whether value has chevrons within it (for cross site scripting).
 * @param {string} value
 * @returns {boolean} true if value is chevron free, else false.
 */
export const xssValidator = (value: string) => {
    for (const restrictChar of restrictedCharacters) {
        if (value.includes(restrictChar)) return false;
    }
    return true;
};

/**
 * Validate whether email's domain is not included in freeEmailDomains.
 * @param {string} email
 * @returns {boolean} true if email is not contained in freeEmailDomains, else false.
 */
export const businessEmailValidator = (email: string) => {
    var enteredDomain = email.substring(email.lastIndexOf('@') + 1);

    if (!freeEmailDomains.has(enteredDomain.toLowerCase())) {
        return true;
    } else {
        return false;
    }
};

/**
 * Validate whether email is a valid email address.
 * @param {string} email
 * @returns {boolean} true if email is valid or empty, else false.
 */
export const emailValidator = (email: string) => {
    if (!email) return true;
    else
        return email.match(
            /([+a-zA-Z0-9_\-\.]+)@(([a-z]{1,3}\.[a-z]{1,3}\.[a-z]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,24}|[0-9]{1,24})/
        )
            ? true
            : false;
};

/**
 * Validate whether value is a positive number.
 * @param {number} value
 * @returns {boolean} true if value is a positive number, else false.
 */
export const positiveNumberValidator = (value: number) => {
    if (!isNaN(value)) {
        return value > 0 ? true : false;
    } else {
        return false;
    }
};

/**
 * Validate whether value is a safe CSS color.
 * @param {string} color - The color string to validate
 * @returns {boolean} true if color is a valid and safe CSS color value, else false.
 */
export const colorValidator = (color: string) => {
    if (!color || typeof color !== 'string') {
        return false;
    }

    // Trim whitespace
    color = color.trim();

    // Allow hex colors: #fff, #ffffff, #ffffffff
    if (/^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6}|[0-9A-Fa-f]{8})$/.test(color)) {
        return true;
    }

    // Allow rgb/rgba: rgb(255,255,255), rgba(255, 255, 255, 0.5)
    if (/^rgba?\(\s*\d{1,3}\s*,\s*\d{1,3}\s*,\s*\d{1,3}\s*(,\s*[\d.]+\s*)?\)$/i.test(color)) {
        return true;
    }

    // Allow hsl/hsla: hsl(360,100%,100%), hsla(360, 100%, 100%, 0.5)
    if (/^hsla?\(\s*\d{1,3}\s*,\s*\d{1,3}%\s*,\s*\d{1,3}%\s*(,\s*[\d.]+\s*)?\)$/i.test(color)) {
        return true;
    }

    // Allow named colors (whitelist common ones used in gradients)
    const validNamedColors = ['white', 'black', 'transparent'];
    if (validNamedColors.includes(color.toLowerCase())) {
        return true;
    }

    return false;
};
